module.exports = __webpack_public_path__ + "media/images/icons/v2/translate-7776da4fcf0ba49fe7ee5507e395fa51.svg";